<template>
  <div class="content extra-page">
    <div class="loader" v-if="extrasLoading">
      <loader/>
    </div>
    <div v-if="!extrasLoading">
      <div class="cover-img" style="background-image: url(/static/img/cover.jpg);">
        <div class="cover">
          <h1>
            {{$t('extras.ourExtras')}}
          </h1>
        </div>
      </div>
      <div class="container">
        <div class="page">
          <div class="allextras">
            <div class="filterextras">
              <form class="filterextras" method="post" id="allfilter">
                <div class="filterextra">
                  <ul>
                    <li :class="{active: currentCategoryIndex === -1}">
                      <input :id="`catextra${categories.length}`" type="radio" name="catextra"
                             @click="currentCategoryIndex = -1">
                      <label class="extra-button"
                             :for="`catextra${categories.length}`">{{$t('extras.allExtras')}}</label>
                    </li>
                    <li
                      v-for="(category, index) in categories"
                      :key="category.id"
                      :index="index"
                      :class="{active: currentCategoryIndex === index}"
                      class=""
                      :item="category">
                      <input :id="`catextra${index}`" type="radio" name="catextra"
                             @click="currentCategoryIndex = index">
                      <label class="extra-button" :for="`catextra${index}`">{{category.text.title}}</label>
                    </li>

                  </ul>
                </div>
              </form>
            </div>
            <div class="extras-list">
              <ul class="extras-grid">
                <template v-for="(category, index) in categories" :index="index" :item="category">
                  <li v-for="(extra, i) in category.extras" :index="i" :key="extra.id" :item="extra"
                      :class="{active: index === currentCategoryIndex}">
                    <div class="extra--card">
                      <span v-if="!!promoLabel(extra)" class="promo-label">{{promoLabel(extra)}}</span>
                      <img v-lazy="`${extra.picture}?w=600&h=400&crop-to-fit`">
                      <h4>{{extra.text.name}}</h4>
                      <div class="card-content">
                        <p :inner-html.prop="extra.text.description | strlen(150)"></p>
                        <div class="white-shadow"></div>
                      </div>
                      <div class="card-footer">
                        <div class="card-button" @click="openModal(extra)">
                          {{$t('extras.learnMore')}}
                        </div>
                      </div>
                    </div>
                  </li>
                  <li v-if="category.extras.length === 0" :class="{active: index === currentCategoryIndex}"
                      class="noExtras">
                    <p>{{$t('extras.noExtras')}}</p>
                  </li>
                </template>
                <li v-for="(extra, i) in allExtras" :index="i" :key="'_' + extra.id" :item="extra"
                    :class="{active: -1 === currentCategoryIndex}">
                  <div class="extra--card">
                    <span v-if="!!promoLabel(extra)" class="promo-label">{{promoLabel(extra)}}</span>
                    <div class="as-image" :style="`background-image: url(${extra.picture}?w=600&h=400&crop-to-fit)`"></div>
                    <h4>{{extra.text.name}}</h4>
                    <div class="card-content">
                      <p :inner-html.prop="extra.text.description | strlen(150)"></p>
                      <div class="white-shadow"></div>
                    </div>
                    <div class="card-footer">
                      <div class="card-button" @click="openModal(extra)">
                        {{$t('extras.learnMore')}}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {setBodyHome} from '../../helpers/body-class.helper';
  import Loader from '../../components/loader.component';
  import {MetaHelper} from "../../helpers/meta.helper";

  export default {
    name: 'extras',
    metaInfo() {
      return MetaHelper.extras(this.$store.state.lang.currentLang)
    },
    components: {Loader},
    computed: {
      ...mapState({
        extrasLoading: s => s.extras.loading,
        extras: s => s.extras.extras.sort((a, b) => (a.number - b.number)),
        categories: s => s.extras.categories.map(c => {
          c.extras = c.extras.sort((a, b) => (a.number - b.number));
          return c;
        }),
        allExtras: s => {
          const extras = [].concat(s.extras.extras, ...s.extras.categories.map(c => c.extras)).sort((a, b) => (a.number - b.number));
          const ids = extras.map(e => e.id);
          return extras.filter((item, index) => {
            return ids.indexOf(item.id) === index;
          });
        },
      }),
    },
    data() {
      return {
        currentCategoryIndex: -1,
      };
    },
    methods: {
      openModal(extra) {
        this.$store.commit('extrasModal/SET_EXTRA', extra);
        window.dispatchEvent(new Event('app:extras-modal.open'));
      },
      promoLabel(extra) {
        if (!extra.discount) {
          return '';
        }
        if (extra.discount.type === 'NEW') {
          return this.$t('extras.discount.NEW');
        }
        if (extra.discount.type === 'FIX') {
          return this.$t('extras.discount.FIX', extra.discount.amount.amount / 100);
        }
        if (extra.discount.type === 'PERCENT') {
          return this.$t('extras.discount.PERCENT', extra.discount.amount.amount);
        }
      },
    },
    async mounted() {
      setBodyHome();
      await this.$store.dispatch('menu/setIndexActive', 3);
      await this.$store.dispatch('extras/fetch', {lang: this.$store.state.lang.currentLang});
    }
  };
</script>

<style scoped>
  .white-shadow {
    position: absolute;
    bottom: 80px;
    right: 0;
    left: 0;
    height: 65px;
    background: -moz-linear-gradient(bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    background: -webkit-linear-gradient(bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    background: linear-gradient(to top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);
  }

  .loader {
    height: 180px;
  }

  .filterextra li.active label {
    background: black;
    color: white;
  }

  .promo-label {
    position: absolute;
    white-space: pre-wrap;
    overflow: hidden;
    left: 0;
    text-overflow: ellipsis;
    top: 40px;
    padding: 10px 20px 10px 20px;
    background: var(--black);
    color: var(--white);
    font-family: 'Sofia Pro', sans-serif;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/extras/extras.vue